module.exports = __webpack_public_path__ + "img/index_sysm.0783529d.png";